import ImagesGallery from "@components/ImagesGallery";
import cx from "classnames";
import styles from "./Partnerships.module.scss";
import "swiper/css/scrollbar";
import { usePageContext } from "@providers/PageProvider";
import { sustainabilityPage } from "@utils/helper";
import _ from "lodash";

export default function Partnerships() {
  const { pageData } = usePageContext();
  const partnershipSection: any =
    sustainabilityPage.formatPartnershipSection(pageData);
  return (
    <div data-scroll-section className={cx("mx-auto", styles.section)}>
      <div className={cx(styles.title)}>
        {_.get(partnershipSection, "subtitle")}
      </div>
      <div className={cx(styles.content)}>
        {_.get(partnershipSection, "description")}
      </div>
      <ImagesGallery
        className={cx(styles.image)}
        galleryName={"partnershipsGallery"}
        isAuto={_.get(partnershipSection, "slider.isAuto")}
        interval={_.get(partnershipSection, "slider.interval")}
        images={_.get(partnershipSection, "slider.slides")}
      />
    </div>
  );
}
